import {
    Icon,
    IconButton,
} from '@mui/material';
import { MRT_ColumnDef } from 'material-react-table';
import { useEffect, useMemo, useState } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { CommonTable } from '../../../_components/table/common.table';
import { PaperTableHeader } from '../../../_components/table/header.table';
import { TABLE_FILTER } from '../../../_const/tableFilter.const';
import { getDate } from '../../../_helpers/dateTime.helper';
import { removeSpaces } from '../../../_helpers/format.helper';
import { handleErrorResponse } from '../../../_helpers/handleResponse.helper';
import { accountService } from '../../../_services/accounts.service';
import { ticketService } from '../../../_services/ticket.service';
import { TicketInfoManageDrawer } from '../../ticket/_components/ticket-infoManageDrawer';
import { TicketCreateDrawer } from '../../ticket/_components/ticket-createDrawer';
import { CaseTicketsUplaodDrawer } from '../../ticket/ticket-caseTicketsUplaodDrawer';

export function CaseTicketList(params: { caseId: number }) {
    const [data, setData] = useState<any>({ items: [], count: 10 });
    const [filter, setFilter] = useState<any>({ ...TABLE_FILTER, order: "desc" });
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const [paymentDate, setPaymentDate] = useState<string>();

    const isAdmin = accountService.isAdmin || accountService.isUser;


    const fetchData = async () => {
        setIsLoading(true);

        var _filter = { ...filter, caseId: params.caseId };

        return await ticketService.getAll(_filter)
            .then(
                json => {
                    setData(json);
                }, handleErrorResponse)
            .finally(() => {
                setIsLoading(false);
            });
    };

    useEffect(() => {
        fetchData();
    }, [filter]);

    const columns = useMemo<MRT_ColumnDef<any>[]>(
        () => [
            {
                id: 'actions',
                header: 'Actions',
                size: 80,
                enableSorting: false,
                enableColumnFilter: false,
                Cell: ({ row }) => (
                    <IconButton
                        color="primary"
                        onClick={() => { navigate(`/Case/${params.caseId}/Ticket/${row.original.id}/${removeSpaces(row.original.ticketType)}`) }}>
                        <Icon>edit</Icon>
                    </IconButton>
                ),
            },
            //{
            //    accessorKey: 'id',
            //    header: 'ID',
            //},
            {
                accessorKey: 'ticketReferenceNumber',
                header: 'Ticket No',
            },
            {
                accessorKey: 'subjectName',
                header: 'Subject',
            },
            {
                accessorKey: 'ticketQuery',
                header: 'Query ?',
            },
            {
                accessorKey: 'ticketType',
                header: 'Type',
            },
            {
                accessorKey: 'status',
                header: 'Status',
            },
            {
                accessorKey: 'created',
                header: 'Created',
                accessorFn: (rowData: any) => <>{rowData.created != null ? getDate(rowData.created) : null}</>,
            },
        ],
        []
    );

    return (
        <>
            {(!data.length && isAdmin) && (
                <PaperTableHeader title="Tickets" buttons={[
                    { icon: "add", label: "Create Ticket", onClick: () => { navigate(`${params.caseId}/Create/Ticket`) } },
                    { icon: "upload", label: "Upload Case Tickets", onClick: () => { navigate(`${params.caseId}/Upload`) } },
                    /*{ icon: "visibility", label: "Go To Case", onClick: () => { navigate(`/Case/${params.caseId}`) } },*/
                ]} />
            )}

            {(!data.length && !isAdmin) && (
                <PaperTableHeader title="Tickets" buttons={[]} />
            )}

            <CommonTable
                columns={columns}
                data={data}
                filter={filter}
                setFilter={setFilter}
                loading={isLoading}
                enableBottomToolbar={true}
                isNested={true}
            />
             <Routes>
                <Route path=":caseId/Create/Ticket" element={<TicketCreateDrawer setPaymentDate={setPaymentDate} onSave={() => { fetchData(); navigate(""); }} onClose={() => { navigate(""); }} />} />
                <Route path=":caseId/Upload" element={<CaseTicketsUplaodDrawer onSave={() => { fetchData(); }} onClose={() => { navigate(""); }} />} />


            </Routes> 

        </>
    );
}
